import PropTypes from 'prop-types';
import { renderChildren } from '@blaze-cms/react-page-builder';
import HierarchyCardsBlock from './HierarchyCardsBlock';
import HierarchyShortCardsBlock from './HierarchyShortCardsBlock';
import LandscapeWithAdCardsBlock from './LandscapeWithAdCardsBlock';
import getBlockClasses from './get-block-classes';
import { HIERARCHY, HIERARCHY_SHORT, LANDSCAPE_WITH_AD } from './constants';

const CardsBlock = ({ type, cardsSeparator, combined, channel, children }) => {
  const parsedChildren = (((children || {}).props || {}).children || [])[1] || [];
  if (!parsedChildren.length) return null;

  const settingsOfFirstChild = ((((parsedChildren[0] || {}).props || {}).component || {}).settings || {});
  const withTitle = !!settingsOfFirstChild.elementTitle;

  if (type === HIERARCHY) {
    return (
      <HierarchyCardsBlock
        cardsSeparator={cardsSeparator === 'true'}
        combined={combined === 'true'}
        channel={channel}
        parsedChildren={parsedChildren}
        withTitle={withTitle} />
     );
  }

  if (type === HIERARCHY_SHORT) {
    return (
      <HierarchyShortCardsBlock
        cardsSeparator={cardsSeparator === 'true'}
        combined={combined === 'true'}
        channel={channel}
        parsedChildren={parsedChildren}
        withTitle={withTitle} />
     );
  }

  if (type === LANDSCAPE_WITH_AD) {
    return (
      <LandscapeWithAdCardsBlock
        cardsSeparator={cardsSeparator === 'true'}
        combined={combined === 'true'}
        channel={channel}
        parsedChildren={parsedChildren}
        withTitle={withTitle} />
     );
  }

  const withAds = !!settingsOfFirstChild.banner;

  const options = {
    cardsSeparator: cardsSeparator === 'true',
    combined: combined === 'true',
    channel,
    withAds,
    withTitle
  };

  return (
    <div data-testid="basic-wrapper" className={getBlockClasses(type, options)}>
      {renderChildren(children)}
    </div>
  );
};

CardsBlock.propTypes = {
  type: PropTypes.string.isRequired,
  cardsSeparator: PropTypes.string,
  combined: PropTypes.string,
  channel: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default CardsBlock;
